import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { useNavigate } from 'react-router-dom'
import { HomeOutlined, AppstoreOutlined, BarsOutlined, LoginOutlined } from '@ant-design/icons';
import './Navigator.css'
import axios from 'axios';

export default function Navigator() {
  const [menuData, setMenuData] = useState([])

  const navigate = useNavigate()

  function chooseMenu(event) {       
    navigate(event.key)
  }

  useEffect(() => {
    let source = axios.CancelToken.source();

    async function fetchData() {
      try {
        let res;
        const cachedData = localStorage.getItem("categories");
        // 如果有缓存数据，直接使用
        if (cachedData) {
          res = JSON.parse(cachedData);
        } else {
          // 从远程获取数据
          res = await axios.get("https://api.360ep.cn/api/category/?type=sep", {
            cancelToken: source.token,
          });

          // 将获取到的数据存储到localStorage中
          localStorage.setItem("categories", JSON.stringify(res.data));
          res = res.data;
        }

        let menuItems = [];
        let menuChildren = [];

        res.data.forEach(item => {
          let subMenu = [];

          item.children.forEach(subItem => {
            subMenu.push({
              label: <span className='pe-category-item'>{subItem.catname}</span>,
              key: "/market/" + subItem.catid
            });
          });

          menuChildren.push({
            type: 'group',
            label: (<span className='pe-category-item'>{item.catname}</span>),
            icon: <LoginOutlined />,
            children: subMenu
          });
        });

        menuItems.push({
          label: (<span className='pe-category'>应用分类</span>),
          key: 'category',
          icon: <BarsOutlined />,
          children: menuChildren
        })

        menuItems.push({
          label: "首页",
          key: '/',
          icon: <HomeOutlined />,
        }, {
          label: '特种塑料应用市场',
          key: '/market',
          icon: <AppstoreOutlined />,
        }, {
          label: '应用案例',
          key: '/application',
          icon: <AppstoreOutlined />,
        });
        setMenuData(menuItems);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
        } else {
          console.log("Error", error.message);
        }
      }
    }

    fetchData();

    return () => {
      source.cancel("Request canceled by user");
    };
  }, []);

  return (
    <div className='menu-wrapper'>
      <Menu mode="horizontal"
        theme="light"
        className="side-menu"
        triggerSubMenuAction="hover"
        items={menuData}
        onClick={chooseMenu}
      />
    </div>
  );
};